module.exports = __webpack_public_path__ + "static/media/logo-light-fr.b7dfae8f.svg";